import React, {useEffect, useContext} from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {RouterContext} from "./Onboarding"

export default function BackButton(props) {
  const history = useHistory();
  const route = useContext(RouterContext)

  let chevronLeft = require("images/onboarding/chevronLeft.png");
  chevronLeft = <img style={{paddingBottom:"3px", paddingRight:"7px"}} src={`/datapulse${chevronLeft}`} />;

  const backFunction = () => {
    let tempRoute = route.get
    let navigateTo = tempRoute.pop()
    route.set(tempRoute)
    return navigateTo
    }

  return (
    <Button
      // style={
      //   props.smaller
      //     ? {
      //         paddingLeft: "70px",
      //         paddingRight: "70px",
      //       }
      //     : props.larger
      //     ? {
      //         paddingLeft: "100px",
      //         paddingRight: "120px",
      //       }
      //     : {
      //         paddingLeft: "85px",
      //         paddingRight: "95px",
      //       }
      // }
      className="py-0 f16 nunito-regular nextBtn validated"
      size="md"
      onClick={() => history.push(backFunction())}>
      {chevronLeft}{` Back`}
    </Button>
  );
}





